class GDLQSModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}

class GDLQSModalDialog extends HTMLElement {
  constructor() {
    super();
    document
      .querySelectorAll('[id^="ModalClose-"]')
      .forEach(function (element) {
        element.addEventListener("click", this.hide.bind(this, false));
      }, this);
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        const productMediaModal = document.querySelector(
          ".product-media-modal"
        );
        const productMediaModalContent = document.querySelector(
          ".product-media-modal__content"
        );

        if (
          (event.pointerType === "mouse" &&
            !event.target.closest("deferred-media, product-model") &&
            !event.target.classList.contains("pdp-zoom-in--to-top")) ||
          !event.target.parentNode.classList.contains("pdp-zoom-in--to-top")
        )
          this.hide();

        // event click check for zoom in back to top
        if (
          event.target.classList.contains("pdp-zoom-in--to-top") ||
          event.target.parentNode.classList.contains("pdp-zoom-in--to-top")
        ) {
          productMediaModal.setAttribute("open", "");
          productMediaModalContent.scrollTop = 0;
          productMediaModalContent.style.transition = "0.2s ease-in-out";
        }
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.documentElement.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
    let miniCart = document.querySelector("cart-drawer");
    if (miniCart.classList.contains("active")) {
      miniCart.classList.remove("active");
    }
  }

  hide() {
    document.documentElement.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");

    let fieldsets = Array.from(this.querySelectorAll("fieldset"));
    let options = [];

    // check all fieldsets for checked radios if value is undefined
    for (let i = 0; i < fieldsets.length; i += 1) {
      const fieldset = fieldsets[i];
      const checkedRadio = Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      );
      if (checkedRadio) {
        checkedRadio.checked = false;
      }
    }

    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}

customElements.define("gdl-quick-shop-modal-dialog", GDLQSModalDialog);
customElements.define("gdl-quick-shop-modal-opener", GDLQSModalOpener);
